import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendOtp, login, restartOtp } from "../../../redux/actions/authActions";
import ReCAPTCHA from "react-google-recaptcha";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import logo from "../../../assets/images/myUti.png";
import logo_mobile from "../../../assets/images/blue_myUti.png"
import paymentIcon from  "../../../assets/images/payment-icon.png" ;
import mobile_payment from "../../../assets/images/blue_payment-icon.png"
import gestion from "../../../assets/images/gestion.png";
import mobile_gestion from "../../../assets/images/blue_gestion.png";
import update from "../../../assets/images/update.png";
import mobile_update from "../../../assets/images/blue_update.png";


import "./Login.css";
import { Button, Container } from "@mui/material";
import { Image } from "@mui/icons-material";

const Login = () => {
  const { otp, errorMsg } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [phone, setPhone] = useState(null);
  const [id, setId] = useState(null);
  const [token, setToken] = useState(null);
  const [otpValue, setOtp] = useState(null);
  const { loading } = useSelector((state) => state.async);
  const recaptchaRef = React.useRef();
  const isMobile = window.innerWidth <= 760

  const redirect = () => {

  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!otp) {

      recaptchaRef.current.executeAsync().then(dtoken => {
        dispatch(sendOtp({ phone: phone, id:id, recaptcha: dtoken }));
        recaptchaRef.current.reset()
      })
    } else {
      dispatch(login({ otp: otpValue, phone: phone, id:id }));
    }
  };

  const CaptchaChange = (token) => {
    setToken(token);

  };
  const refreshOtp = () => {
    window.location.reload();
  };

  const Services = () => {
    const text = isMobile ? 'כל המידע שלכם במקום אחד!' : 'מהיום כל המידע על המשאית שלכם במקום אחד!';
   return <Box className="right_side" >
    {!isMobile && <img src={logo} alt="logo" className="myLogo" />}
    {isMobile &&  <hr/>}
    <div className="subTitle"> {text} </div>
    <div className="boxes">
      <div className="singleBox">
        <div className="icon"><img src={isMobile? mobile_update : update} alt="עדכונים על המשאית שלכם " /></div>
        <div>עדכונים על המשאית שלכם </div>
      </div>
      <div className="singleBox">
        <div className="icon"><img src={isMobile? mobile_gestion : gestion} alt="ניהול פשוט של מסמכי הרכב" /></div>
        <div>ניהול פשוט של מסמכי הרכב</div>
      </div>
      <div className="singleBox">
        <div className="icon"><img src={isMobile? mobile_payment : paymentIcon} alt="מעקב אחר מצב התשלומים" /></div>
        <div>מעקב אחר מצב התשלומים</div>
      </div>

    </div>

  </Box>
  }


  if (otp === 'fresh') {
    // refreshOtp()
  }

  return (
    <div className="login_page">
      <div className="r_side">
        <Container className="flex">
          { !isMobile && <Services/> }
        
          <Box
            className={"box_login"}
            component="form"
            onSubmit={handleSubmit}

            sx={{
              '& .MuiTextField-root': { m: 1, width: '25ch' },
            }}
            noValidate
            autoComplete="off"
          >
              {isMobile && <img src={logo_mobile} alt="logo" className="myLogo" />}
            <h2 className="login_title">התחברות לאזור האישי</h2>
            <div>


              {!otp || otp === 'fresh' ? (
                <>
                  <TextField
                    style={{ width: '100%' }}
                    required
                    label="מספר ת.ז / ח.פ. / רישוי"
                    onChange={(e) => setId(e.target.value)}
                    placeholder={"אנא הזן מספר ת.ז, ח.פ. או רישוי"}
                  />

                  <TextField
                    style={{ width: '100%' }}
                    required
                    label="מספר נייד"
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder={"אנא הזן מספר נייד"}
                  />

                  <ReCAPTCHA
                    size="invisible"
                    ref={recaptchaRef}
                    className="captcha-st"
                    sitekey={process.env.CAPTCHA_SITE_KEY || '6LcWoMkiAAAAAEcV1Wd0QDnbGF4b98aVZkV-JK6h'}
                    onChange={CaptchaChange}
                  />
                </>
              ) : ''}

              {otp && otp != 'fresh' ? (
                <div>
                  <TextField
                    style={{ width: '100%' }}
                    required
                    onChange={(e) => setOtp(e.target.value)}
                    label="קוד אימות"
                    placeholder={"אנא הזן סיסמא שנשלחה בSMS"}
                  />

                  <div className="restert" onClick={refreshOtp}>
                    לא קיבלתי קוד, שלח שוב
                  </div>
                </div>
              ) : ""}

            </div>
            <LoadingButton loading={loading} onClick={handleSubmit} variant="contained" className="login-btn">
              {!otp ? "שלחו לי קוד לנייד" : "התחבר"}
            </LoadingButton>
            {errorMsg && <div className="errorMsg"> {errorMsg} </div>}
            { isMobile && <Services/> }
            <div
              onClick={redirect}
              className="contactLink"
            >
              צור קשר
            </div>
          </Box>
        </Container>

      </div>
    </div>
  );
};

export default Login;
